export default __webpack_public_path__ + "static/article-upgrade-your-car-with-small-loan-0548f555e441b667ee61f08874b5f582.jpg";